// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  portId: __t.u64().primaryKey().name("port_id"),
  settlementId: __t.u64().name("settlement_id"),
  firmId: __t.u64().name("firm_id"),
  state: __t.string(),
  generation: __t.u32(),
  exported: __t.u32(),
  lifetimeCapU: __t.u32().name("lifetime_cap_u"),
  coinsPaid: __t.i64().name("coins_paid"),
  coinsReceived: __t.i64().name("coins_received"),
  sovEarned: __t.i64().name("sov_earned"),
  sovSpent: __t.i64().name("sov_spent"),
  lastError: __t.string().name("last_error"),
  lastEpoch: __t.u64().name("last_epoch"),
  createdAt: __t.timestamp().name("created_at"),
  updatedAt: __t.timestamp().name("updated_at"),
});
